<template>
    <tinymce-editor
        :id="tinymceId"
        :key="tinymceKey"
        :value="content"
        :init="init"
        :width="width"
        :height="height"
        :resize="resize"
        :disabled="disabled"
        @pause="handlePaste"
        @input="onInput"
    />
</template>
<script>
    import TinymceEditor from '@tinymce/tinymce-vue';
    // 引入配置信息
    import defaultConfig from './config'
    const isEmpty = function(value){
        return value == '' || value == null;
    }
    export default {
        name: 'Editor',
        components: { TinymceEditor },
        props: {
            id: {
                type: String,
                default: function() {
                    return 'tinymce-' + Date.now() +  Math.floor(Math.random() * 1000)
                }
            },
            // 内容
            content: {
                type: String,
                default: ''
            },
            // 是否禁用
            disabled: {
                type: Boolean,
                default: false
            },
            // 宽度
            width: {
                type: [String, Number],
                default: '100%'
            },
            // 高度
            height: {
                type: [String, Number],
                default: 450
            },
            // 是否允许拖动
            resize: {
                type: [String, Boolean],
                default: true
            },
            // 菜单栏
            menubar: {
                type: String,
                default: ''
            },
            // 工具栏
            toolbar: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                tinymceId: this.id,
                tinymceKey:0,
                init: Object.assign(defaultConfig, {
                    // 组件值覆盖默认配置
                    width: this.width,
                    height: this.height,
                    resize: this.resize,
                    menubar: isEmpty(this.menubar) ? defaultConfig.menubar : this.menubar,
                    toolbar: isEmpty(this.toolbar) ? defaultConfig.toolbar : this.toolbar,
                })
            }
        },
        mounted(){

        },
        methods: {
            onInput(content) {
                this.$emit('update:content', content)
            },
            handlePaste(){
                // 粘贴内容后，等待DOM更新
                this.$nextTick(() => {
                    // 使用tinymce的selection对象选中最后
                    const editor = tinymce.get(this.tinymceKey);
                    editor.selection.select(editor.getBody(), true);
                    // 将光标移动到最后
                    editor.execCommand('JustifyLeft');
                    // 强制tinymce更新，以便光标位置正确显示
                    this.tinymceKey += 1;
                });
            }
        }
    }
</script>
